import { getSupabase, isSupabaseConfigured } from './supabase';

const LS_CLOUD_ADS = 'mingo_cloud_ads_v1';

function safeParse(raw, fallback) {
  try {
    const v = JSON.parse(raw);
    return Array.isArray(v) ? v : fallback;
  } catch {
    return fallback;
  }
}

export function loadCloudAdsCache() {
  if (typeof window === 'undefined') return [];
  return safeParse(window.localStorage.getItem(LS_CLOUD_ADS), []);
}

function saveCloudAdsCache(rows) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(LS_CLOUD_ADS, JSON.stringify(rows));
}

function pickFirstText(arr, fallback = 'all') {
  if (!Array.isArray(arr) || !arr.length) return fallback;
  const v = String(arr[0] || '').trim().toLowerCase();
  return v || fallback;
}

function inferPlacement(adType = '', exposureTier = '') {
  const t = String(adType).toLowerCase();
  const e = String(exposureTier).toLowerCase();
  if (t.includes('story') || e.includes('story')) return 'storyHome';
  if (t.includes('discover') || e.includes('discover')) return 'discover';
  return 'all';
}

function inferMediaKind(adType = '') {
  const t = String(adType).toLowerCase();
  if (t.includes('video')) return 'video';
  if (t.includes('story') || t.includes('image') || t.includes('text')) return 'image_text';
  return 'all';
}

function mapDbAdToMatcherAd(row) {
  return {
    id: row.id,
    title: row.title || 'Sponsored',
    description: row.description || '',
    image: row.image_url || '',
    video_url: row.video_url || '',
    link: row.link_url || '/shorts',
    type: 'feed',
    active: true,
    startDate: row.starts_at || null,
    endDate: row.ends_at || null,
    language: pickFirstText(row.target_languages, 'all'),
    region: pickFirstText(row.target_regions, 'global'),
    category: 'all',
    priority: row.exposure_tier === 'premium' ? 80 : 60,
    placement: inferPlacement(row.ad_type, row.exposure_tier),
    media_kind: inferMediaKind(row.ad_type),
    source: 'cloud',
  };
}

export async function syncCloudAdsFromSupabase() {
  if (!isSupabaseConfigured) return loadCloudAdsCache();
  const sb = getSupabase();
  if (!sb) return loadCloudAdsCache();
  const nowIso = new Date().toISOString();
  const { data, error } = await sb
    .from('business_ads')
    .select('id,title,description,image_url,video_url,link_url,ad_type,target_regions,target_languages,exposure_tier,starts_at,ends_at,status')
    .in('status', ['approved', 'active'])
    .or(`ends_at.is.null,ends_at.gte.${nowIso}`)
    .order('created_at', { ascending: false })
    .limit(200);
  if (error) return loadCloudAdsCache();
  const mapped = (data || []).map(mapDbAdToMatcherAd);
  saveCloudAdsCache(mapped);
  return mapped;
}

